import React, { useCallback } from "react";
import { Pressable, Text, View } from "react-native";
import Image from "@components/common/Image";
import { Grayscale } from "react-native-color-matrix-image-filters";
import Caret from "../../assets/svg/Caret";
import colors from "../../constants/color";
import handleCMSNavigation from "../../utils/handleCMSNavigation";

const Rewards = ({ rewards = [], disabled = false }) => {
  return (
    <View>
      {Array.isArray(rewards) &&
        rewards.map((item) => {
          const { title, sub_title, cta_link, cta_type, icon } = item;
          return (
            <RewardCard
              key={title + sub_title}
              {...{ title, sub_title, cta_link, cta_type, icon, disabled }}
            />
          );
        })}
    </View>
  );
};

const GrayscaleImage = ({ imageProps }) => (
  <Grayscale>
    <Image {...imageProps} />
  </Grayscale>
);
const RewardCard = (props) => {
  const {
    title,
    sub_title,
    cta_link,
    icon,
    disabled = false,
    cta_type,
  } = props;
  const onPress = () => {
    handleCMSNavigation(cta_link, cta_type);
  };

  const renderSubtitle = useCallback(() => {
    if (!sub_title || typeof sub_title !== "string") {
      return "";
    }
    if (sub_title.trim().startsWith("*")) {
      return (
        <View style={{ flexDirection: "row" }}>
          <Text
            style={{
              color: disabled ? "#B3B3B3" : colors.primary,
              fontFamily: "NotoSansDevanagari-Regular",
              marginRight: 4,
            }}
          >
            *
          </Text>
          <Text
            style={{
              color: disabled ? "#B3B3B3" : "black",
              fontFamily: "NotoSansDevanagari-Regular",
            }}
          >
            {sub_title.trim().slice(1)}
          </Text>
        </View>
      );
    } else {
      return (
        <Text
          style={{
            color: disabled ? "#B3B3B3" : "black",
            fontFamily: "NotoSansDevanagari-Regular",
          }}
        >
          {sub_title}
        </Text>
      );
    }
  }, [sub_title, disabled]);

  const imageProps = {
    source: { uri: icon },
    style: {
      height: 60,
      width: 60,
      marginRight: 13,
      opacity: disabled ? 0.5 : 1,
    },
    resizeMode: "contain",
  };
  return (
    <Pressable
      onPress={onPress}
      disabled={disabled}
      style={{
        backgroundColor: "white",
        borderRadius: 10,
        padding: 10,
        flexDirection: "row",
        marginTop: 10,
        elevation: 1,
        paddingTop: 16,
        // alignItems: "",
      }}
      android_ripple={{
        color: "rgba(0,0,0,0.08)",
        borderless: false,
      }}
    >
      {disabled ? (
        <GrayscaleImage imageProps={imageProps} />
      ) : (
        <Image {...imageProps} />
      )}
      <View
        style={{
          flex: 1,
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <View style={{ paddingBottom: 6, width: "90%" }}>
          <Text
            style={{
              fontSize: 30,
              fontFamily: "NotoSansDevanagari-Regular",
              color: disabled ? "#B3B3B3" : "black",
            }}
          >
            {title}
          </Text>
          <Text
            style={{
              fontFamily: "NotoSansDevanagari-Regular",

              color: disabled ? "#B3B3B3" : "rgba(0,0,0,0.56)",
            }}
          >
            {renderSubtitle(sub_title)}
          </Text>
        </View>
        <View style={{ marginLeft: "auto", flexDirection: "row" }}>
          <Caret strokeColor={disabled ? "#B3B3B3" : colors.primary} />
        </View>
      </View>
    </Pressable>
  );
};

export default Rewards;
